module.exports = __webpack_public_path__ + "media/food_safeties/bamko-insulated-bag-a6d0b0a9.jpg";